import 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { Form as Form$1, Formik } from 'formik';
import { selectFromTheme } from '@thisisbud/sc-utils';
import { jsx } from 'react/jsx-runtime';

let _ = t => t,
  _t;
const formClassName = 'bui-form';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledForm = /*#__PURE__*/styled(Form$1).withConfig({
  displayName: "StyledForm",
  componentId: "sc-w4gxvu-0"
})(_t || (_t = _`
  * + & {
    margin-top: ${0};
  }

  .bui-h3 + & {
    margin-top: ${0};
  }

  .bui-paragraph + & {
    margin-top: ${0};
  }
`), selectFromTheme('spacingSmallDefault'), selectFromTheme('spacingXXSmallDefault'), selectFromTheme('spacingLargeDefault'));

/**
 * A form component that handles child inputs.
 *
 * Internally the component uses [Formik](https://formik.org) to handle form validation and submission as well as input states.
 * The props for the `Form` component match their counterparts in the `Formik` component.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { Form } from '@thisisbud/bui-react-form'
 * import { InputGroup } from '@thisisbud/bui-react-input-group'
 * import { Input } from '@thisisbud/bui-react-input'
 *
 * function Example() {
 *   return (
 *     <Form>
 *       <InputGroup label='username'>
 *         <Input name='username'/>
 *       </InputGroup>
 *     </Form>
 *   )
 * }
 * ```
 */
function Form(props) {
  const {
    action,
    busy,
    children,
    className,
    describedBy,
    enableReinitialize,
    encType,
    initialErrors,
    initialTouched,
    initialValues,
    method,
    onReset,
    onSubmit,
    validate
  } = props;
  return /*#__PURE__*/jsx(Formik, {
    enableReinitialize: enableReinitialize,
    initialErrors: initialErrors,
    initialTouched: initialTouched,
    initialValues: initialValues,
    validate: validate,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    onReset: onReset,
    onSubmit: onSubmit,
    children: /*#__PURE__*/jsx(StyledForm, {
      action: action,
      "aria-busy": busy,
      "aria-describedby": describedBy,
      className: classnames(formClassName, className),
      encType: encType,
      method: method,
      noValidate: true,
      target: "self",
      children: children
    })
  });
}
Form.defaultProps = {
  onSubmit() {} // eslint-disable-line @typescript-eslint/no-empty-function
};

Form.displayName = 'Form';

export { Form, formClassName };
